interface RevcallLogoProps {
  size?: number;
  className?: string;
  /** Any CSS colour; the logo is drawn in a single colour. */
  color?: string;
}

/**
 * The Revcall mark, the one on the home page (Navbar, r.png): a tall bar and
 * a disc at its top right. Redrawn as vectors from that image (750 x 750:
 * bar 202-375 x 125-589, disc centred at 500,196, radius 84) so that it takes
 * any colour; Kevin, 2026-10-07: "tu peux le colorer autrement".
 */
export function RevcallLogo({ size = 16, className, color = 'currentColor' }: RevcallLogoProps) {
  return (
    <svg width={size} height={size} viewBox="152 92 482 517" role="img" aria-label="Revcall" className={className}>
      <rect x="202" y="125" width="173" height="464" fill={color} />
      <circle cx="500" cy="196" r="84" fill={color} />
    </svg>
  );
}
